import { styled } from '@linaria/react';

export const PageWrapper = styled.div`
    min-height: calc(100vh - 60px);
    background: #f8f9fa;

    .hidden {
        display: none;
    }
`;

export const PageContainer = styled.div`
    background: transparent;
    max-width: 1200px;
    margin: 0 auto;
    padding: 1.5rem 0;

    @media (max-width: 768px) {
        padding: 1rem;
        
        &.responsive-mobile {
            margin: 15px;
            padding: 15px;
        }
    }
`;

export const PageHeader = styled.div`
    background: white;
    border: 1px solid #ddd;
    border-radius: 4px;
    display: flex;
    align-items: center;
    gap: 30px;
    margin-bottom: 30px;
    padding: 2rem;

    @media (max-width: 768px) {
        flex-direction: column;
        text-align: center;
        gap: 20px;
        padding: 1rem;
    }

    #logo-container {
        flex-shrink: 0;

        img {
            height: 80px;
            width: auto;
        }
    }

    .front-heading {
        h3 {
            color: #333;
            font-size: 1.8rem;
            margin-bottom: 10px;
            font-weight: 600;
        }

        p {
            margin: 8px 0;
            color: #666;

            a {
                color: #0066cc;
                text-decoration: none;

                &:hover {
                    text-decoration: underline;
                }
            }

            .about-button {
                background: none;
                border: none;
                color: #0066cc;
                text-decoration: underline;
                cursor: pointer;
                font-size: inherit;
                font-family: inherit;
                padding: 0;

                &:hover {
                    color: #004499;
                    text-decoration: none;
                }

                &:focus {
                    outline: 2px solid #0066cc;
                    outline-offset: 2px;
                }
            }
        }

        .glyphicon-circle-question-mark::before {
            content: '?';
            display: inline-block;
            width: 16px;
            height: 16px;
            background: #0066cc;
            color: white;
            border-radius: 50%;
            text-align: center;
            font-size: 12px;
            line-height: 16px;
            margin-right: 5px;
        }
    }
`;